import { AdditionalSVGProps } from '@/models/Svg';

export const NavigationPrevIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#062747', ...rest } = props;

  return (
    <svg
      width='14'
      height='36'
      viewBox='0 0 14 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.6507 35.6056C11.8816 35.9495 12.3475 36.0411 12.6914 35.8102C13.0353 35.5794 13.1269 35.1134 12.896 34.7695L1.76366 18.1875L12.896 1.60559C13.1269 1.26169 13.0353 0.795738 12.6914 0.564857C12.3475 0.333977 11.8816 0.425598 11.6507 0.769501L0.247376 17.755C0.157574 17.8823 0.110381 18.034 0.110241 18.1875C0.110144 18.2944 0.13284 18.4021 0.179831 18.5031C0.198644 18.5438 0.221182 18.583 0.247335 18.62L11.6507 35.6056Z'
        fill={fill}
      />
    </svg>
  );
};
